import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export enum SYSTEM_TYPE {
  WIALON = 'wialon',
  OMNICOMM = 'omnicomm',
  AXENTA = 'axenta',
  GELIOS = 'gelios',
  FORTMONITOR = 'fortmonitor',
  GLONASSOFT = 'glonasssoft',
}

export type SystemType =
  | 'wialon'
  | 'omnicomm'
  | 'axenta'
  | 'gelios'
  | 'fortmonitor'
  | 'glonasssoft'
  | null

interface SystemState {
  selectedSystem: SystemType
  setSelectedSystem: (system: SystemType) => void
  clearSelectedSystem: () => void
}

export const useSystemStore = create<SystemState>()(
  persist(
    (set) => ({
      selectedSystem: null,

      setSelectedSystem: (system: SystemType) => {
        set({ selectedSystem: system })
      },

      clearSelectedSystem: () => {
        set({ selectedSystem: null })
      },
    }),
    {
      name: 'system-storage',
    }
  )
)
